import { Button } from '@progress/kendo-react-buttons'
import { SearchBody } from '../../../components/layouts'
import { useAccessibleAuthority, usePageTitle } from '../../../components/hooks'
import StructureSearchCondition from './StructureSearchCondition'
import StructureSearchResultList from './StructureSearchResultList'
import { Authority } from '../../../gateway/system/Authority'

export default function StructureSearch() {
  useAccessibleAuthority(Authority.Builder, Authority.Material, Authority.Branch)
  usePageTitle('構造比率・歩掛マスタメンテナンス')

  return (
    <SearchBody
      pageable={false}
      leftPane={<StructureSearchCondition />}
      rightPane={<StructureSearchResultList />}
      rightPaneButton={
        <>
          <Button onClick={() => ''}>戻る</Button>
          <Button onClick={() => ''} themeColor="primary">
            数値クリア
          </Button>
          <Button onClick={() => ''} themeColor="primary">
            登録/修正
          </Button>
        </>
      }
    />
  )
}
